import StoryCarousel from './StoryCarousel';
import TimelineView from './TimelineView';
import AdSlot from './AdSlot';

const dayLabel = (dateStr) => {
  const date = new Date(dateStr + 'T00:00:00Z');
  const today = new Date();
  const todayUTC = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()));
  const diffDays = Math.round((todayUTC - date) / 86400000);
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  return date.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
};

const StoryList = ({ stories, view, keyPrefix = '' }) =>
  stories.map((story, index) => (
    <div key={`${keyPrefix}${story.id}`}>
      {view === 'timeline' ? <TimelineView story={story} /> : <StoryCarousel story={story} />}
      {(index + 1) % 2 === 0 && (
        <AdSlot slotId={`in-feed-${keyPrefix}${index}`} format="horizontal" className="mb-8 sm:mb-12" />
      )}
    </div>
  ));

export const StoryFeedList = ({ stories, view, dayGroups }) => {
  if (stories.length === 0) {
    return (
      <div className="text-center py-12" data-testid="empty-feed-message">
        <p className="text-gray-600 text-base sm:text-lg">No stories available yet.</p>
        <p className="text-gray-500 text-sm mt-2">
          Articles are being ingested. Check back in a few minutes.
        </p>
      </div>
    );
  }

  if (dayGroups) {
    return dayGroups
      .filter((group) => group.stories.length > 0)
      .map((group) => (
        <div key={group.dayOffset} data-testid={`day-group-${group.dayOffset}`}>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-400 mb-4 sm:mb-6 pb-2 border-b border-gray-200">
            {dayLabel(group.date)}
          </h2>
          <StoryList stories={group.stories} view={view} keyPrefix={`d${group.dayOffset}-`} />
        </div>
      ));
  }

  return <StoryList stories={stories} view={view} />;
};
